'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

exports.getEntities = getEntities;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shared = require('./shared');

var _constants = require('../constants');

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function getEntities() {
  var origText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var spans = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _Array;

  var labelColors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var showWhitespace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var text = [].concat(_toConsumableArray(origText)); // fix off-by-one errors caused by emoji

  var formatText = function formatText(text) {
    return (0, _util.replaceWsChar)(text, _shared.Char, showWhitespace);
  };

  var offset = 0;

  var result = (_Array = Array()).concat.apply(_Array, _toConsumableArray(spans.map(function (_ref, i) {
    var start = _ref.start,
        end = _ref.end,
        label = _ref.label;
    var elements = [];
    var prefix = text.slice(offset, start).join('');
    var noEnt = label == _constants.NO_ENTITY;

    if (prefix.length) {
      elements.push(_react2["default"].createElement('span', {
        key: i
      }, formatText(prefix)));
    }

    elements.push(_react2["default"].createElement(_shared.Mark, {
      outside: noEnt,
      key: 'ent-' + i,
      label: label,
      color: labelColors[label]
    }, formatText(text.slice(start, end).join('')), label && !noEnt && _react2["default"].createElement(_shared.Label, null, label)));
    offset = end;
    return elements;
  })));

  var suffix = text.slice(offset, text.length).join('');

  if (suffix.length) {
    result.push(_react2["default"].createElement('span', {
      key: -1
    }, formatText(suffix)));
  }

  return result;
}

var styles = function styles(theme) {
  return {
    root: {
      lineHeight: 1.7
    }
  };
};

var Spans = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Spans, _React$Component);

  function Spans() {
    _classCallCheck(this, Spans);

    return _possibleConstructorReturn(this, (Spans.__proto__ || Object.getPrototypeOf(Spans)).apply(this, arguments));
  }

  _createClass(Spans, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          nowrap = _props.nowrap,
          children = _props.children,
          classes = _props.classes;
      var cardStyle = config.cardStyle,
          labelColors = config.labelColors,
          showWhitespace = config.showWhitespace;
      var textSize = (0, _util.getTextSize)(content.text);
      var entities = getEntities(content.text, content.spans, labelColors, showWhitespace);
      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Content, {
        cardStyle: cardStyle,
        textSize: textSize,
        nowrap: nowrap
      }, _react2["default"].createElement('div', {
        className: classes.root
      }, entities.map(function (span) {
        return span;
      }))), children);
    }
  }]);

  return Spans;
}(_react2["default"].Component), _class2.id = 'ner', _temp)) || _class);
exports["default"] = Spans;